$(document).ready(function () {
    var path = window.location.pathname;
    var page = path.split('/')[1].toLowerCase();
    $('#' + page).addClass('active');

    $('.dd_select').on('click', function () {
        $('.dd-select').toggleClass('active');
    });

    $('.dd-select li').on('click', function () {
        $('.dd-select li').removeClass('active');
        $(this).addClass('active');

        $('.dd_select').text($(this).text());
    });

    $('.phone-container').each(function (i) {
        var curContainer = $('.phone-container')[i];
        var number = $(curContainer).children('.phone-num');
        if (number.text().length === 0) {
            $(curContainer).hide();
        }
    });

    // $(document).trigger("enhance.tablesaw");

    $('.team-grid > li').each(function (i) {
        var name = $(this).children("a").children('.team-member-details').children('.name').text();
        var elements = $('img[alt="' + name + '"]');
        var elementsCount = elements.length;
        var hiddenElements = 0;

        if (elementsCount > 1 && hiddenElements < elementsCount) {
            $(elements).each(function () {
                if ($(this).parent('a').parent('li').data('hiddenduplicate') == "Hidden") {
                    $(this).parent('a').parent('li').hide();
                    hiddenElements = hiddenElements + 1;
                }
            });
        }
    });

    // enquire.register('screen and (min-width: 1024px)', function () {
    //   setTimeout(function(){
    //     $('.moneypass').addClass('active');
    //   }, 6500);

    //   setTimeout(function(){
    //     $('.find-atms').addClass('active');
    //   }, 7500);
    // });
});

// Accordions
// $('.accordions h2').each(function () {
//     var $this = $(this);

//     // create unique id for a11y relationship
//     var id = 'accordion-' + $this.index();

//     // wrap the content and make it focusable
//     $this.nextUntil('h2').wrapAll('<div id="' + id + '" aria-hidden="true">');
//     var panel = $this.next();

//     // Add the button inside the <h2> so both the heading and button semanics are read
//     $this.wrapInner('<button aria-expanded="false" aria-controls="' + id + '">');
//     var button = $this.children('button');

//     // Toggle the state properties
//     button.on('click', function (e) {
//         e.preventDefault();
//         var state = $(this).attr('aria-expanded') === 'false' ? true : false;
//         $(this).attr('aria-expanded', state);
//         $(this).parent('h2').toggleClass('is-active');
//         panel.attr('aria-hidden', !state);
//     });
// });

// // Tabs
// $('.tabs').each(function () {
//   // The class for the container div
//   var tabContainer = $(this);
//   var tabContainerIndex = $(this).index();
//   var wrapTabs = $('.tab-con', tabContainer);
//   // The setup
//   $('ul.tab-list', tabContainer).empty().attr('role', 'tablist');
//   $('.tab-content', tabContainer).each(function () {
//     var tabHeading = $(this).find("> .tab-title").html();
//     var tabHeadingID = 'tabs' + tabContainerIndex + 'tab' + $(this).index();
//     $('ul.tab-list', tabContainer).append('<li><a href="#' + tabHeadingID + '">' + tabHeading + '</a></li>');
//     $(this).attr('id', tabHeadingID);
//   });
//   $('[role="tablist"] > li', tabContainer).attr('role', 'presentation');
//   $('[role="tablist"] a', tabContainer).attr({
//     'role': 'tab',
//     'tabindex': '-1'
//   });
//   // Make each aria-controls correspond id of targeted section (re href)
//   $('[role="tablist"] a', tabContainer).each(function () {
//     $(this).attr('aria-controls', $(this).attr('href').substring(1));
//   });
//   // Make the first tab selected by default and allow it focus
//   $('[role="tablist"] li:first-child a', tabContainer).attr({
//     'aria-selected': 'true',
//     'tabindex': '0'
//   });
//   // Make each section focusable and give it the tabpanel role
//   $('section', tabContainer).attr({
//     'role': 'tabpanel'
//   });
//   // Make first child of each panel focusable programmatically
//   $('section > *:first-child', tabContainer).attr({
//     'tabindex': '0'
//   });
//   // Make all but the first section hidden (ARIA state and display CSS)
//   $('[role="tabpanel"]:not(:first-of-type)', tabContainer).attr({
//     'aria-hidden': 'true'
//   });
//   // Change focus between tabs with arrow keys
//   $('[role="tab"]', tabContainer).on('keydown', function (e) {
//     // define current, previous and next (possible) tabs
//     var tabCurrent = $(this);
//     var tabPrev = $(this).parents('li').prev().children('[role="tab"]');
//     var tabNext = $(this).parents('li').next().children('[role="tab"]');
//     var tabTarget;
//     // find the direction (prev or next)
//     switch (e.keyCode) {
//       case 37:
//         tabTarget = tabPrev;
//         break;
//       case 39:
//         tabTarget = tabNext;
//         break;
//       default:
//         tabTarget = false;
//         break;
//     }
//     if (tabTarget.length) {
//       tabCurrent.attr({
//         'tabindex': '-1',
//         'aria-selected': null
//       });
//       tabTarget.attr({
//         'tabindex': '0',
//         'aria-selected': true
//       }).focus();
//     }
//     // Hide panels
//     $('[role="tabpanel"]', tabContainer).attr('aria-hidden', 'true');
//     // Show panel which corresponds to target
//     $('#' + $(document.activeElement).attr('href').substring(1)).attr('aria-hidden', null);
//   });
//   // Handle click on tab to show + focus tabpanel
//   $('[role="tab"]', tabContainer).on('click', function (e) {
//     e.preventDefault();
//     var tabID = $(this).attr('href');
//     // remove focusability [sic] and aria-selected
//     $('[role="tab"]', tabContainer).attr({
//       'tabindex': '-1',
//       'aria-selected': null
//     });
//     // replace above on clicked tab
//     $(this).attr({
//       'aria-selected': true,
//       'tabindex': '0'
//     });
//     // Hide panels
//     $('[role="tabpanel"]', tabContainer).attr('aria-hidden', 'true');
//     // show corresponding panel
//     // $('#' + $(this).attr('href').substring(1)).attr('aria-hidden', null);
//     $('section' + tabID).attr('aria-hidden', null);
//   });

//   var tabsContainerWidth = $('.tab-con', tabContainer).outerWidth();
//   var tabsWidth = $('ul.tab-list', tabContainer).outerWidth();
//   var scrollWidth = tabsWidth - tabsContainerWidth;

//   if (tabsWidth > tabsContainerWidth) {
//     tabContainer.addClass('scroll-right');
//     wrapTabs.on('scroll', function () {
//       if (wrapTabs.scrollLeft() >= tabsWidth - tabsContainerWidth) {
//         tabContainer.removeClass('scroll-right');
//       } else {
//         tabContainer.addClass('scroll-right');
//       }
//       if (wrapTabs.scrollLeft() > 1) {
//         tabContainer.addClass('scroll-left');
//       } else {
//         tabContainer.removeClass('scroll-left');
//       }
//     });
//   }

// });

$(function () {
    $(".bars .bar-wrapper .bar, .bars .bar-wrapper .bar-2").each(function () {
        var percent = $(this).data('percent');

        setTimeout(function () {
            $('.bar-wrapper .bar-2').slideDown(1000);
        }, 1500);
        setTimeout(function () {
            $('.bar-wrapper .bar').slideDown(2000);
        }, 2500);

        $(this).animate({
            'height': percent + '%'
        }, 1000);
    });
});

//Business Bankers / Our Team stuff
$(function () {
    var $bankers = $('.team-grid li');

    // clone applications to get a second collection
    var $data = $bankers.clone();

    $('.bb-location-select li').on('click', function () {
        var $bankerFilter = $(this).data('location');
        $('.bb-location-select li').removeClass('active');
        $(this).addClass('active');

        if ($bankerFilter == "All") {
            $bankers.each(function () {
                $(this).show('slow')
            });
            hideDuplicates();
        } else {
            hideDuplicates();

            $bankers.each(function () {
                if ($(this).data('location').indexOf($bankerFilter) > -1) {
                    $(this).show('slow');
                } else {
                    $(this).hide('slow');
                }
            });

        }

    });

    $('.bb-location-select li').on('keypress', function (e) {
        if (e.which == 13) {
            var $bankerFilter = $(this).data('location');
            $('.bb-location-select li').removeClass('active');
            $(this).addClass('active');

            if ($bankerFilter == "All") {
                $bankers.each(function () {
                    $(this).show('slow')
                });
                hideDuplicates();
            } else {
                hideDuplicates();

                $bankers.each(function () {
                    if ($(this).data('location').indexOf($bankerFilter) > -1) {
                        $(this).show('slow');
                    } else {
                        $(this).hide('slow');
                    }
                });
            }
        }
    });

    /*$('.bb-location-select li[data-location="Creve Coeur"]').hide();*/

    $('.business-bankers-listing .bb-location-select li[data-location="Headquarters"]').hide();
    $('.home-loans .bb-location-select li[data-location="Headquarters"]').hide();
    $('.select-a-home-loan-officer .bb-location-select li[data-location="Headquarters"]').hide();


    $('.bb-location-select li').on('click', function () {
        $('.bb-location-select.open').removeClass('open');
        $('.bb-location-container .toggle span').remove();
        if ($('.bb-location-select li').hasClass('active')) {
            $('<span>: ' + $('.bb-location-select li.active').attr('data-location') + '</span>').appendTo('.bb-location-container .toggle');
        }
    });

    $('.bb-location-select li').on('keypress', function (e) {
        if (e.which == 13) {
            $('.bb-location-select.open').removeClass('open');
            $('.bb-location-container .toggle span').remove();
            if ($('.bb-location-select li').hasClass('active')) {
                $('<span>: ' + $('.bb-location-select li.active').attr('data-location') + '</span>').appendTo('.bb-location-container .toggle');
            }
        }
    });

    $('.bb-location-container .toggle').on('click', function () {
        $(this).toggleClass('open');
        $('.bb-location-select').toggleClass('open');
    });

    $('.bb-location-container .toggle').on('keypress', function (e) {
        if (e.which == 13) {
            $(this).toggleClass('open');
            $('.bb-location-select').toggleClass('open');
        }
    });

    function hideDuplicates() {
        $('.team-grid > li').each(function (i) {
            var name = $(this).children("a").children('.team-member-details').children('.name').text();
            var elements = $('img[alt="' + name + '"]');
            var elementsCount = elements.length;
            var hiddenElements = 0;
            if (elementsCount > 1) {
                $(elements).each(function () {
                    if ($(this).parent('a').parent('li').data('hiddenduplicate') == "Hidden" && hiddenElements < elementsCount) {
                        $(this).parent('a').parent('li').hide();
                        hiddenElements = hiddenElements + 1;
                    }
                });
            }
        });
    }

    //Remove apply now link if empty
    //$('.team-member-details a.apply-now:not([href])').each(function () {
    //    $(this).hide();
    //});

    //Subnav Functionality - START
    $('.locations-selection span.more').on('click', function () {
        $('.locations-selection').toggleClass('active');
    });

    $('.locations-selection span.more').on('keypress', function (e) {
        if (e.which === 13) {
            $('.locations-selection').toggleClass('active');
            $('.locations-selection ul li a:last').on('focusout', function () {
                $('.locations-selection.active').removeClass('active');
            });
        }
    });



});